import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from 'react-bootstrap';
import '../styles/commonStyles.css';
import { ArrowLeftShort, ArrowRightShort } from 'react-bootstrap-icons';
import Api from '../services/request-service';
import { API_URL } from '../services/api_url';
import Loader from '../components/Loader';
import {ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';

const Home = () => {
    const navigate = useNavigate();
    const [rewards, setRewards] = useState([]);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
    const [totalItems,setTotalItems] = useState(0);
    const [currentPage,setCurrentPage] = useState(1);
    const [limit,setLimit] = useState(10);
    const [hasNext,setHasNext] = useState(false);
    const [hasPrevious,setHasPrevious] = useState(false);

    const handlePrevious = () => {
        let currentPageData = currentPage - 1
        setCurrentPage(currentPage - 1);
        fetchRewards(currentPageData);
    };

    const handleNext = () => {
        let currentPageData = currentPage + 1
        setCurrentPage(currentPage + 1);
        fetchRewards(currentPageData);
    };

    const fetchRewards = async (page) => {
        try {
            setLoading(true);
            const response = await Api.get(API_URL.REWARD_LIST+`/?page=${page}&limit=${limit}`, true);
            if (response.status === 200) {
                setRewards(response.data.rewards);
                setTotalItems(response.data.pagination.totalItems);
                setCurrentPage(response.data.pagination.currentPage);
                setLimit(response.data.pagination.itemsPerPage);
                setHasNext(response.data.pagination.hasNextPage);
                setHasPrevious(response.data.pagination.hasPreviousPage);
            }
            else {
                setRewards([]);
                setTotalItems(0);
                setCurrentPage(1);
                setLimit(10);
                setHasNext(false);
                setHasPrevious(false);
                if(response.status === 401) {
                    toast.error("Unauthorized")
                    setTimeout(() => {
                        navigate("/login");
                    }, 3000);
                }
                else {
                    toast.error(response.message);
                }
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchRewards(currentPage);
    }, []);


    return (
        <>
            <ToastContainer />
            {loading && <Loader loading={loading} />}
        <div className="container">
            <>
            <Row className="mb-4 justify-content-between">
                <Col className="d-flex justify-content-start">
                    <button className="add-reward-btn" onClick={() => navigate("/add-reward")}>+ Add reward</button>
                </Col>
                <Col className="d-flex justify-content-end align-items-center">
                    <button 
                        className="pagination-btn" 
                        onClick={handlePrevious} 
                        disabled={!hasPrevious}
                    >
                        <ArrowLeftShort size={26} color={hasPrevious ?  '#FFFFFF'  : '#1D1B20'}/>
                    </button>
                    <span className="mx-2">{`${(currentPage - 1) * itemsPerPage + 1}-${currentPage * itemsPerPage} of ${totalItems}`}</span>
                    <button 
                        className="pagination-btn" 
                        onClick={handleNext} 
                        disabled={!hasNext}
                    >
                        <ArrowRightShort size={26} color={hasNext ? '#FFFFFF' :  '#1D1B20'}/>
                    </button>
                </Col>
            </Row>
            <div className="d-flex justify-content-between align-items-center">
                
            </div>
            <table className="table">
                <thead>
                    <tr >
                        <th className="col-6 border-left-1" >Reward title</th>
                        <th >Quantity</th>
                        <th >Fancoins</th>
                        <th >Dropped</th>
                        <th >Status</th>
                    </tr>
                </thead>
                <tbody>
                    { rewards?.length > 0 ? rewards?.map((reward, index) => (
                        <tr key={index} onClick={() => navigate(`/reward-details/${reward?._id}`)} style={{cursor: 'pointer'}}>
                            <td >{reward?.title}</td>
                            <td>{reward?.quantity || '--'}</td>
                            <td>{reward?.fancoins}</td>
                            <td>{dayjs(reward?.createdAt).format('DD MMM YYYY, HH:mm')}</td>
                            <td>{reward?.activated ? 'Active' : 'Inactive'}</td>
                        </tr>
                    )) : <tr><td colSpan={5} className="text-center">No rewards found</td></tr>}
                </tbody>
            </table>
            </>
        </div>
        </>
    );
}

export default Home;